import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, ArrowUpRightIcon } from "lucide-react";
import { useSeo } from "../hooks/useSeo";
import { PageHero } from "../components/ui/PageHero";
import { CtaLink } from "../components/ui/CtaLink";
import { CtaBand } from "../components/ui/CtaBand";
import { Reveal } from "../components/ui/Reveal";
import { SERVICE_GROUPS } from "../data/navigation";
const GROUP_LEADS: Record<string, string> = {
  Websites: "Sites designed for how your industry's customers search, compare and buy.",
  Growth: "Help the right people find you — and choose you.",
  Ongoing: "Hosting, upkeep and tools that keep your site working for you."
};
export function Services() {
  useSeo({
    title: "Services",
    description: "Website design for small businesses, restaurants, automotive, contractors and more — plus local SEO, redesigns and hosting & maintenance.",
    path: "/services"
  });
  return <>
      <PageHero crumbs={[{
      label: "Services"
    }]} eyebrow="Services" title="Websites, growth and ongoing care." lead="Everything NEXORA builds and maintains, in one place. Choose a service to see what's included, who it's for and how it works." actions={<>
            <CtaLink to="/contact" track="services_hero_build" size="lg" data-id="element-946" data-mp="1kg7nst9szk1s">Build My Website <ArrowRightIcon className="h-4 w-4" data-id="element-947" data-mp="1kic2m698q3gu" /></CtaLink>
            <CtaLink to="/pricing" variant="ghost" track="services_hero_pricing" size="lg" data-id="element-948" data-mp="1pe981hiytpeu">See pricing</CtaLink>
          </>} data-id="element-945" data-mp="27ynvngafnxrl" />
      {SERVICE_GROUPS.map(group => <section key={group.title} className="shell section border-b border-line" data-id="element-949" data-mp="1zcys9gyc3ly9">
          <Reveal className="mb-10 grid gap-4 lg:grid-cols-[1fr_1fr] lg:items-end" data-id="element-950" data-mp="23f3liekvegkd">
            <h2 className="t-h2" data-id="element-951" data-mp="23cr1lvvjxw4o">{group.title}</h2>
            <p className="t-lead max-w-[46ch] text-muted lg:justify-self-end lg:text-right" data-id="element-952" data-mp="50inkkl6sfvi">{GROUP_LEADS[group.title]}</p>
          </Reveal>
          <ul className="auto-grid" style={{
        "--min": "300px"
      } as React.CSSProperties} data-id="element-953" data-mp="935ac7303alu">
            {group.items.map((item, i) => <Reveal as="li" key={item.href} delay={Math.min(i, 6) * 0.04} className="h-full" data-id="element-954" data-mp="17deu7jgoatmu" data-mpi={i}>
                <Link to={item.href} className="group flex h-full flex-col rounded-[clamp(1rem,1.2vw,1.5rem)] border border-line bg-ink-2 p-[clamp(1.25rem,1.8vw,2.25rem)] transition-[transform,border-color] duration-200 ease-out hover:-translate-y-1 hover:border-line-strong" data-id="element-955" data-mp="1ld65hcft1vx5">
                  <item.icon className="h-6 w-6 text-accent-soft" aria-hidden data-id="element-956" data-mp="1qay9h4tq58hp" />
                  <h3 className="t-h3 mt-8" data-id="element-957" data-mp="250x4wztwa5th">{item.label}</h3>
                  <p className="mt-2 text-muted" data-id="element-958" data-mp="252gjmlzwk8t5">{item.blurb}</p>
                  <span className="mt-auto inline-flex items-center gap-2 pt-8 text-[15px] text-fg-2 group-hover:text-fg" data-id="element-959" data-mp="2022no2bkspbh">
                    Learn more <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-960" data-mp="2dyzei3rp26sd" />
                  </span>
                </Link>
              </Reveal>)}
          </ul>
        </section>)}
      <CtaBand source="services" data-id="element-961" data-mp="2xl16b5vl6j8q" />
    </>;
}